module.exports = __webpack_public_path__ + "img/logo-house-medium-2.428e28cc.svg";